import React, { useMemo } from 'react';
import MirsTable from 'components/general/table/Table.js';
import { findArray } from 'helpers/utils';
import { NocMemo as Noc } from 'components/presentation/Noc';
import Competitor from 'components/presentation/Competitor';
import { useViewport } from 'components/general/useViewPort'
import Label from "components/general/Label";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { FieldStatsColumns, GoalKeeperStatsColumns } from '../components/Columns';

function WpoPlayerStats({ data, team }) {

  const { mirs_rsc, mirs_discipline } = useUrlFriendlyToParameters()
  const { breakPoint } = useViewport();
  const isMobile = (breakPoint === "sm" || breakPoint === "xs")

  let athletes = findArray(data?.results?.items, { startSortOrder: [team] })?.teamAthletes;
  let teamTotal = findArray(data?.results?.items, { startSortOrder: [team] })?.statsItems;

  let fieldAthletes = athletes?.filter(ath => ath.functionDescription !== 'Goalkeeper')
  let goalkeepers = athletes?.filter(ath => ath.functionDescription === 'Goalkeeper')

  let statsArrayField = ['TOTAL', 'TOTAL', 'ACT', 'CNT', 'DRV', 'EXT', '6M', '6MF', 'PTY', 'CAT', 'CNR', 'TFL', 'ST', 'REB', 'BLC', 'SP', 'TYC', 'TYF', 'DS', 'M6', 'CS', '2EXC', 'FRP', 'EXC'];
  let statsArrayGoal = ['TOTAL_GK', 'TOTAL_GK', 'ACT_GK', 'CNT_GK', 'DRV_GK', 'EXT_GK', '6M_GK', '6MF_GK', 'PTY_GK', 'CAT_GK', 'CNR_GK'];

  let itemsField = statsArrayField.map((item) => {
    let val = findArray(teamTotal, { code: [item] })
    return {
      code: item, value: val?.value, attempt: val?.attempt, percent: val?.percent
    }
  })

  let itemsGoal = statsArrayGoal.map((item) => {
    let val = findArray(teamTotal, { code: [item] })
    return {
      code: item, value: val?.value, attempt: val?.attempt, percent: val?.percent
    }
  })

  let extraFieldAth = {
    athlete: { code: '100000' },
    bib: 100000,
    title: <strong><Label data='HeaderTotals' /></strong>,
    statsItems:
      itemsField,
  }

  let extraGoalkeepers = {
    athlete: { code: '100001' },
    bib: 100001,
    title: <strong><Label data='HeaderTotals' /></strong>,
    statsItems:
      itemsGoal,
  }

  //Before to inser check if exist yet

  fieldAthletes = fieldAthletes?.filter(item => item.code !== 100000)
  goalkeepers = goalkeepers?.filter(item => item.code !== 100001)

  if (!fieldAthletes) fieldAthletes = []
  if (!goalkeepers) goalkeepers = []

  fieldAthletes?.push(extraFieldAth)
  goalkeepers?.push(extraGoalkeepers)

  let competitorCode = findArray(data?.results?.items, { startSortOrder: [team] })?.participant?.code;
  let participant = findArray(data?.results?.items, { startSortOrder: [team] })?.participant;


  let _captionField = <CaptionTeam participant={participant} />

  const fieldStatColumns = useMemo(() => FieldStatsColumns(), []);
  const goalKeeperStatsColumns = useMemo(() => GoalKeeperStatsColumns({ isMobile: isMobile }), [isMobile]);
  return (
    <>{ }

      <MirsTable
        id={`mirs-table-player-statistics-${team + '-' + mirs_rsc}-${competitorCode}`}
        caption={_captionField}
        data={fieldAthletes}
        columns={fieldStatColumns}
        keyRow={"athlete-code"}
        initialSortBy={[]}
        colsExtendedVisible={isMobile ? '4,4,4,4,4,5' : '9,5,8'}
        showNavExtendedData={isMobile ? true : true}
        //colIndex={isMobile ? 1 : 1}
        colIndex={1}
      //hiddenColumns={['Exclusion', 'CentreForwardExclusion']}
      />
      <MirsTable
        id={`mirs-table-goalkeeper-statistics-${team + '-' + mirs_rsc}-${competitorCode}`}
        data={goalkeepers}
        columns={goalKeeperStatsColumns}
        keyRow={"athlete-code"}
        initialSortBy={[]}
        colsExtendedVisible={(breakPoint === "sm" || breakPoint === "xs") ? '5,4' : undefined}
        showNavExtendedData={(breakPoint === "sm" || breakPoint === "xs") ? true : false}
        colIndex={(breakPoint === "sm" || breakPoint === "xs") ? 1 : undefined}
      />
    </>
  );
}

export default WpoPlayerStats;

function CaptionTeam({ participant }) {
  return (
    <div className='d-flex align-items-center'>
      <div className='d-none d-md-block me-1'>
        <Noc {...participant?.organisation} />
      </div>
      <strong>
        <Competitor hidePicture={true} {...participant} />
      </strong>
    </div>
  )
}


